import type { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { Road } from "$src/domain/map/Road";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { inject, injectable } from "tsyringe";
import { GeoLocation, GeoLocation as Location } from "$src/domain/projects/ProjectDetail";

@injectable()
export class ComputeRoadFromPoints {
    
    constructor(@inject(ServiceTokens.LocalityRepository) private localityRepository: ILocalityRepository) {}

    async execute(from: Location, to: Location): Promise<Road> {
        var road = await this.localityRepository.getRoadFromPoints(from, to);
        return road;
    }
}

export const ComputeRoadFromPointsToken = Symbol('ComputeRoadFromPointsToken');    

export interface RoadFromPoints {
    from?: GeoLocation;
    to?: GeoLocation;
}